import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Box, Tabs, Skeleton, Stack } from '@mantine/core';
import { semanticColors } from 'theme';
import NotificationItem from './NotificationItem';
import EmptyState from './EmptyState';

const LoadingSkeleton = () => (
  <Stack gap={0}>
    {[0, 1, 2].map((i) => (
      <Box
        key={i}
        style={{
          padding: '14px 20px',
          display: 'flex',
          gap: 12,
          borderBottom: `1px solid ${semanticColors.border.default}`
        }}
      >
        <Skeleton circle height={42} width={42} style={{ flexShrink: 0 }} />
        <Box style={{ flex: 1 }}>
          <Skeleton height={20} width="70%" />
          <Skeleton height={16} width="100%" mt={4} />
          <Skeleton height={14} width="30%" mt={6} />
        </Box>
      </Box>
    ))}
  </Stack>
);

const NotificationList = ({ onNotificationClick, onFilterChange, onDelete }) => {
  const { notifications, filter, isLoading } = useSelector((state) => state.notification);

  return (
    <>
      <Tabs
        value={filter}
        onChange={(val) => onFilterChange(val)}
        variant="default"
        styles={{
          root: {
            borderBottom: `1px solid ${semanticColors.border.default}`
          },
          tab: {
            minHeight: 44,
            textTransform: 'none',
            fontSize: '0.85rem',
            fontWeight: 600,
            letterSpacing: '0.01em'
          },
          list: {
            flexWrap: 'nowrap'
          }
        }}
      >
        <Tabs.List grow>
          <Tabs.Tab value="all">All</Tabs.Tab>
          <Tabs.Tab value="unread">Unread</Tabs.Tab>
        </Tabs.List>
      </Tabs>
      <Box style={{ minHeight: 200, maxHeight: 400, overflowY: 'auto' }}>
        {(() => {
          if (isLoading && notifications.length === 0) return <LoadingSkeleton />;
          if (notifications.length === 0) return <EmptyState />;
          return (
            <Stack gap={0}>
              {notifications.map((notif) => (
                <NotificationItem key={notif.id} notification={notif} onClick={onNotificationClick} onDelete={onDelete} />
              ))}
            </Stack>
          );
        })()}
      </Box>
    </>
  );
};

NotificationList.propTypes = {
  onNotificationClick: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default NotificationList;
